import PageLayout from './PageLayout.vue'
export default PageLayout
